import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class RsmEscalationApi extends ApiCommon {
  protected backend = environment.api.backend;

  getRsmEscalations(pageEvent, q?: any, query?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (q) {
      builder.q = q;
    }

    if (query) {
      builder.query = query;
    }

    return this.apiServer.rsmEscalation.getRsmEscalations(builder.build());
  }

  getRsmEscalation(rsmEscalationNo): Observable<any> {
    return this.apiServer.rsmEscalation.getRsmEscalation(rsmEscalationNo);
  }

  createRsmEscalation(data): Observable<any> {
    return this.apiServer.rsmEscalation.createRsmEscalation(data);
  }

  updateRsmEscalation(data): Observable<any> {
    return this.apiServer.rsmEscalation.updateRsmEscalation(data);
  }

  updateRsmEscalationTicketAdd(data): Observable<any> {
    return this.apiServer.rsmEscalation.updateRsmEscalationTicketAdd(data);
  }

  createExchangeTicket(data): Observable<any> {
    return this.apiServer.rsmEscalation.createExchangeTicket(data);
  }

  updateRsmEscalationStatus(data): Observable<any> {
    return this.apiServer.rsmEscalation.updateRsmEscalationStatus(data);
  }

  serverFileUpload(rsmEscalationNo, formData): Observable<any> {
    return this.apiServer.rsmEscalation.serverFileUpload(rsmEscalationNo, formData);
  }

  deleteFile(data): Observable<any> {
    return this.apiServer.rsmEscalation.deleteFile(data);
  }

  getTicketInfoList(ticketNo, params: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.params = params;

    return this.apiServer.rsmEscalation.getTicketInfoList(ticketNo, builder.build());
  }

  deletetTicketMapping(rsmEscalationNo, ticketNo): Observable<any> {
    return this.apiServer.rsmEscalation.deletetTicketMapping(rsmEscalationNo, ticketNo);
  }
}
